import React from "react";

// Palette + costanti condivise dal modulo Investimenti (estratte da InvestmentsSheet).
export const TEAL = "#2DD4BF";
export const MINT = "#5EEAD4";
export const GREEN = "#00FF87";
export const RED = "#FF4D4D";
export const AMBER = "#F5A623";
export const CLASS_COLOR = { crypto: TEAL, stock: "#5B8DEF" };
export const CLASS_LABEL = { crypto: "Crypto", stock: "Azioni / ETF" };

export const VERDICT_BADGE = {
  positive: { borderColor: "rgba(0,255,135,0.5)", color: GREEN, background: "rgba(0,255,135,0.08)" },
  warning: { borderColor: "rgba(245,166,35,0.5)", color: AMBER, background: "rgba(245,166,35,0.08)" },
  neutral: { borderColor: "rgba(255,255,255,0.18)", color: "rgba(255,255,255,0.7)", background: "rgba(255,255,255,0.04)" },
};

export const RISK_OPTIONS = [
  { id: "prudente", label: "Prudente" },
  { id: "bilanciato", label: "Bilanciato" },
  { id: "dinamico", label: "Dinamico" },
];

export const plColor = (v) => (v >= 0 ? GREEN : RED);
export const pctStr = (v) => `${v >= 0 ? "+" : ""}${Number(v).toLocaleString("it-IT", { maximumFractionDigits: 2 })}%`;
export const ccyOptions = (instrumentCcy) => [
  ...new Set([(instrumentCcy || "EUR").toUpperCase(), "EUR", "USD"]),
];

export const Sparkline = ({ values, color = TEAL }) => {
  if (!values || values.length < 2) return null;
  const min = Math.min(...values);
  const max = Math.max(...values);
  const span = max - min || 1;
  const pts = values
    .map((v, i) => {
      const x = (i / (values.length - 1)) * 100;
      const y = 31 - ((v - min) / span) * 28;
      return `${x.toFixed(2)},${y.toFixed(2)}`;
    })
    .join(" ");
  return (
    <svg viewBox="0 0 100 32" preserveAspectRatio="none" className="h-12 w-full" data-testid="perf-sparkline">
      <polyline points={pts} fill="none" stroke={color} strokeWidth="1.5" strokeLinejoin="round" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
    </svg>
  );
};

export const CoachStat = ({ label, value, sub, testid }) => (
  <div className="rounded-[8px] border border-white/[0.06] bg-[#050508] px-3 py-2.5" data-testid={testid}>
    <p className="caps-tag text-white/35">{label}</p>
    <p className="mono mt-1 text-[15px] font-light tabular text-white/90">{value}</p>
    {sub && <p className="caps-tag mt-0.5 text-white/30">{sub}</p>}
  </div>
);

export const TerminalInput = ({ label, value, onChange, placeholder, suffix, testid, type = "number", hint }) => (
  <div className="flex-1">
    <label className="caps-tag mb-1.5 block text-white/40">{label}</label>
    <div className="flex h-11 items-center gap-2 rounded-[8px] border border-white/10 bg-[#050508] px-3 focus-within:border-[#2DD4BF]/50">
      <input
        type={type}
        inputMode={type === "number" ? "decimal" : "text"}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testid}
        className="mono h-full w-full bg-transparent text-sm font-light tabular text-white placeholder:text-white/25 focus:outline-none"
      />
      {suffix && <span className="mono text-xs text-white/40">{suffix}</span>}
    </div>
    {hint && <p className="mt-1 text-[10px] font-light leading-snug text-white/30">{hint}</p>}
  </div>
);

// Selettore valuta compatto per il prezzo di carico (es. USD / EUR).
export const CurrencyToggle = ({ value, onChange, options }) => (
  <div className="flex items-center gap-0.5" data-testid="avg-currency-toggle">
    {options.map((c) => {
      const active = value === c;
      return (
        <button
          key={c}
          type="button"
          onClick={() => onChange(c)}
          data-testid={`avg-ccy-${c}`}
          aria-pressed={active}
          className={`mono rounded-[4px] px-1.5 py-0.5 text-[10px] tracking-wide transition-colors duration-150 ${
            active ? "bg-[#2DD4BF]/15 text-[#5EEAD4]" : "text-white/35 hover:text-white/70"
          }`}
        >
          {c}
        </button>
      );
    })}
  </div>
);
